/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import toast from "react-hot-toast";
import { CREATE_MULTI_BOX } from "../graphql/createMultiBox.mutation";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateMultiBoxCampMethods extends IPluginMethodMap {
  CreateMultiBoxCamp(args: any): Promise<any>;
}

export class CreateMultiBoxCampService implements IAgentPlugin {
  readonly methods: ICreateMultiBoxCampMethods;

  constructor() {
    this.methods = {
      CreateMultiBoxCamp: this.CreateMultiBoxCamp.bind(this),
    };
  }

  async CreateMultiBoxCamp(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        let variables: any = {
          data: this.transformData(args?.items),
        };
        const res = await client.mutate({
          mutation: CREATE_MULTI_BOX,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          toast.success(
            "Package ordered successfully. Please pay at mas camp."
          );
          return res?.data;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        toast.error(
          _display_message?.extensions?.display_message ??
            "Something went wrong"
        );
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private transformData(data) {
    console.log("datadata74", data);
    return data.map((entry) => {
      const { selectedDiscount, items } = entry;

      const transformedEntry = {
        presentation: items.presentation,
        section: items.section,
        referal: items.referal,
        items: items.items,
      };

      if (selectedDiscount) {
        transformedEntry.discountCode = selectedDiscount;
      }
      if (items?.availableTime) {
        transformedEntry.availableTime = items?.availableTime;
      }
      if (items?.address) {
        transformedEntry.address = items?.address;
      }

      return transformedEntry;
    });
  }
}
